import { createFeatureSelector, createSelector } from '@ngrx/store';
import { productTypesFeatureKey, ProductTypesState } from './product-types.reducer';

export const selectProductTypesState =
  createFeatureSelector<ProductTypesState>(productTypesFeatureKey);

export const selectAllProductTypes = createSelector(
  selectProductTypesState,
  (state: ProductTypesState) => state.productTypes
);

export const selectAllProductTypeCategories = createSelector(selectProductTypesState,
  (state: ProductTypesState) => state.productTypeCategories
);

export const selectAllProductModelClasses = createSelector(selectProductTypesState,
  (state: ProductTypesState) => state.productModelClasses
);

export const selectAllProductModels = createSelector(selectProductTypesState,
  (state: ProductTypesState) => state.productModels
);
